/**
 * Dedup Module Configuration
 *
 * De-duplication wizard for identifying and merging duplicate records.
 * Accessible via Settings → Data Cleanup — admin only.
 * Does not show as a top-level sidebar item.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const dedupModule: AppModule = {
    id: 'dedup',

    navigation: {
        label: 'Data Cleanup',
        icon: 'copy-check',
        path: '/dedup',
        order: 92,
        moduleKey: 'settings.data_cleanup',

        // Not shown as top-level sidebar item — accessed via Settings
        showInSidebar: false,

        // Admin only

        pages: [],
    },

    routes,
}

export default dedupModule
